var map = {
	"./de/impressum.mdx": 99329,
	"./de/index.mdx": 47164,
	"./de/rechtliche-grundlagen.mdx": 28503,
	"./en/imprint.mdx": 98047,
	"./en/index.mdx": 13536,
	"./en/legal-framework.mdx": 5904,
	"./fr/cadre-juridique.mdx": 57297,
	"./fr/impressum.mdx": 53356,
	"./fr/index.mdx": 3925,
	"./it/colophon.mdx": 40980,
	"./it/index.mdx": 48362,
	"./it/quadro-giuridico.mdx": 78096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 64504;
module.exports = webpackContext;